import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from "primereact/progressspinner";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import axios from "axios";

function CareMain() {
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);

  const [firstName, setFirstName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: 10,
    page: 0,
  });

  const fetchCareList = async (filters = {}) => {
    setLoading(true);
    try {
      const params = {
        pageNumber: lazyParams.page + 1,
        pageSize: lazyParams.rows,
        ...filters,
      };

      const response = await axios.get(
        `${process.env.REACT_APP_BASEURL}backoffice/care/list/filter`,
        { params }
      );

      const responseData = response.data?.data || [];
      setData(responseData);
     setTotalRecords(response.data?.data?.[0]?.totalSize || 0);

    } catch (error) {
      console.error("Error fetching care list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const filters = {};
    if (firstName) filters.firstName = firstName;
    if (phoneNumber) filters.phoneNumber = phoneNumber;

    fetchCareList(filters);
  }, [lazyParams]);

  const handleSearch = () => {
    setLazyParams({ ...lazyParams, page: 0, first: 0 });
    fetchCareList({ firstName, phoneNumber });
  };

  const handleClear = () => {
    setFirstName("");
    setPhoneNumber("");
    setLazyParams({ ...lazyParams, page: 0, first: 0 });
    fetchCareList();
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "20px" }}>
        Care List
      </h2>

      {/* Search Section */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
          marginBottom: "20px",
          alignItems: "center",
        }}
      >
        <InputText
          placeholder="Search by First Name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
        <InputText
          placeholder="Search by Mobile No"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
        />
        <Button label="Search" icon="pi pi-search" onClick={handleSearch} />
        <Button
          label="Clear"
          icon="pi pi-times"
          className="p-button-secondary"
          onClick={handleClear}
        />
      </div>

      {/* Data Table */}
      {loading ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <ProgressSpinner />
        </div>
      ) : (
        <DataTable
          value={data}
          lazy
          paginator
          totalRecords={totalRecords}
          first={lazyParams.first}
          rows={lazyParams.rows}
          onPage={(e) => setLazyParams(e)}
        >
          <Column field="clientId" header="Client ID" />
          <Column field="firstName" header="First Name" />
          <Column field="lastName" header="Last Name" />
          <Column field="patientCode" header="Patient Code" />
          <Column field="phoneNumber" header="Phone Number" />
          <Column field="policyNumber" header="Policy Number" />
          <Column field="type" header="Type" />
        </DataTable>
      )}
    </div>
  );
}

export default CareMain;
